class ServiceError extends Error {
  constructor(message) {
    super(message);
    this.name = "ServiceError";
    
    Object.setPrototypeOf(this, ServiceError.prototype);
  }
}

export default ServiceError;
